
export function getImageUrl(imageData: any) {
    return imageData ?
        'data:image/png;base64,' + imageData
        : 'https://www.gravatar.com/avatar/?d=mp'
}

export function getLabel(variable: boolean) : string {
    return variable ? "Yes" : "No";
}

export function randomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}